import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberWallMaterials(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/wall_materials/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberWallMaterials.js